import { Box, Button, Typography, Paper } from '@mui/material';
import styles from './styles.module.scss';
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Captcha } from '@/components/Captcha';
import { FormInput } from '@/components';
import { useFormViewModel } from './FormViewModel';
import { Controller } from 'react-hook-form';

interface Props {
  captchaVerified: boolean;
  onSubmit: (email: string) => void;
  onCaptchaVerifiedChange: (value: string | null) => void;
  tNs: string;
}

export const Form: FC<Props> = ({
  onSubmit,
  captchaVerified,
  onCaptchaVerifiedChange,
  tNs,
}) => {
  const { t } = useTranslation(tNs);
  const { handleSubmit, control, errors, isValid, email } = useFormViewModel();

  return (
    <Paper className={styles.paper}>
      <Typography variant={'h3'} className={styles.formTitle}>
        {t('form.title')}
      </Typography>
      <form onSubmit={(e): void => void handleSubmit(() => onSubmit(email))(e)}>
        <Controller
          control={control}
          name={'email'}
          render={({ field }): React.ReactElement => (
            <FormInput
              {...field}
              className={styles.input}
              type="email"
              placeholder={t('form.emailPlaceholder')}
              error={!!errors.email}
              errorMessage={t('form.invalidEmail')}
            />
          )}
        />
        <Box className={styles.captchaWrapper}>
          <Captcha
            className={styles.captchaContainer}
            onChange={onCaptchaVerifiedChange}
          />
        </Box>
        <Button
          className={styles.submit}
          disabled={!isValid || !captchaVerified}
          variant={'contained'}
          color={'secondary'}
          type={'submit'}
        >
          {t('form.buttonTitle')}
        </Button>
      </form>
      <Typography className={styles.hint}>{t('form.hint')}</Typography>
    </Paper>
  );
};
